var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("circle",{"cx":"12","cy":"12","r":"9","key":1}),React.createElement("polyline",{"points":"12 7 12 12 15 15","key":2})]);
}

Clock.defaultProps = {"className":"icon icon-tabler icon-tabler-clock","width":"24","height":"24","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Clock;

Clock.default = Clock;
